import resolvers from "./resolvers"
import cycle from "./defaultData/cycle"

const data = {
  insWizard: {
    __typename: "InsWizard",
    cycle,
    isEditMode: null,
    nextURL: null,
    prevURL: null,
    questionGroupId: null,
    questions: []
  },
  insDemo: {
    __typename: "InsightsDemoTenant",
    accessToken: null,
    cycleUuid: null,
    tenantUuid: null
  },
  insGlobal: {
    __typename: "InsGlobal",
    cycleId: null,
    interestId: null,
    tenant: null
  }
}

const setup = (client) => {
  client.cache.writeData({data})
  client.addResolvers(resolvers)
}

export default {
  setup
}
